
const state = {
  campaign_id: undefined,
  end_time: '',
  id: null,
  inspection_date: '',
  start_time: '',
  user_id: undefined,
}

export const requiredFields = [
  { key: 'campaign_id' },
  { key: 'end_time' },
  { key: 'inspection_date' },
  { key: 'start_time' },
]

export default state
